import classNames from "classnames";
import React, { MouseEventHandler } from "react";

type Props = {
  onClick: MouseEventHandler<HTMLButtonElement>;
  icon: React.ReactNode;
  extraClasses?: string;
  disabled?: boolean;
  size?: "large" | "default" | "small";
  colorVariant?: "default" | "purple";
  hasShadow?: boolean;
};

export const SettingsIconButton: React.FC<Props> = ({
  onClick,
  icon,
  extraClasses,
  disabled,
  size = "default",
  colorVariant = "default",
  hasShadow = true,
}) => {
  const colorVariants = {
    default: `border-[#C8D2DE] bg-white text-[#253747] hover:border-[#3F5266] hover:bg-[#4C637B0D] ${
      hasShadow ? "hover:shadow-settings-grey" : ""
    }`,
    purple: `border-[#6938EF] bg-[#6938EF] text-[#FFFFFF] hover:border-[#3F5266] ${
      hasShadow ? "hover:shadow-settings-purple" : ""
    } disabled:bg-[#BDB4FE] disabled:border-[#BDB4FE]`,
  };

  const sizes = {
    large: "h-10 w-10",
    default: "h-9 w-9",
    small: "h-8 w-8",
  };

  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={classNames(
        "flex items-center justify-center rounded-lg border transition-all duration-300",
        colorVariants[colorVariant],
        sizes[size],
        extraClasses ?? "",
      )}>
      {icon}
    </button>
  );
};
